import { render, staticRenderFns } from "./AdminProdPrice.vue?vue&type=template&id=429452c5&scoped=true&"
import script from "./AdminProdPrice.vue?vue&type=script&lang=js&"
export * from "./AdminProdPrice.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdPrice.vue?vue&type=style&index=0&id=429452c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429452c5",
  null
  
)

export default component.exports